import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
} from '@mui/material';
import AddNameTagTab from './AddNameTagTab';
import GeneralInquiryTab from './GeneralInquiryTab';
import OAPIInquiryTab from './OAPIInquiryTab';
import UpdateTokenInfoTab from './UpdateTokenInfoTab';
import AdvertisingInquiryTab from './AdvertisingInquiryTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`inquiry-tabpanel-${index}`}
      aria-labelledby={`inquiry-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `inquiry-tab-${index}`,
    'aria-controls': `inquiry-tabpanel-${index}`,
  };
}

const InquiryManagement: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabValue, setTabValue] = useState(0);

  // Initialize tab value from URL parameter
  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      const tabIndex = parseInt(tabParam, 10);
      if (tabIndex >= 0 && tabIndex <= 4) {
        setTabValue(tabIndex);
      }
    }
  }, [searchParams]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    // Update URL parameter
    setSearchParams({ tab: newValue.toString() });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" gutterBottom>
        Inquiry Management
      </Typography>
      
      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="inquiry management tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Add Name Tag Requests" {...a11yProps(0)} />
          <Tab label="General Inquiries" {...a11yProps(1)} />
          <Tab label="OAPI Inquiries" {...a11yProps(2)} />
          <Tab label="Update Token Info" {...a11yProps(3)} />
          <Tab label="Advertising Inquiries" {...a11yProps(4)} />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <AddNameTagTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <GeneralInquiryTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={2}>
        <OAPIInquiryTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={3}>
        <UpdateTokenInfoTab />
      </TabPanel>
      
      <TabPanel value={tabValue} index={4}>
        <AdvertisingInquiryTab />
      </TabPanel>
    </Box>
  );
};

export default InquiryManagement;
